import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { TranslatePipe } from 'app/core/i18n/translate.pipe';
import { UnpricedUomDialogData } from '../../interfaces/dialog-data.interface';

@Component({
  selector: 'app-unpriced-uom-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatIconModule, TranslatePipe],
  templateUrl: './unpriced-uom-modal.component.html',
})
export class UnpricedUomModalComponent {
  amountText = '';

  constructor(
    private dialogRef: MatDialogRef<UnpricedUomModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UnpricedUomDialogData
  ) {}

  get amount(): number {
    const raw = (this.amountText ?? '').trim();
    return raw === '' || raw === '.' ? 0 : parseFloat(raw);
  }

  // cantidad convertida a la unidad base (UMB)
  get converted(): number {
    return this.amount * (this.data.factor || 1);
  }

  onAmountInput(value: string): void {
    let raw = (value ?? '').replace(/[^0-9.]/g, '');
    const firstDot = raw.indexOf('.');
    if (firstDot !== -1) {
      raw = raw.slice(0, firstDot + 1) + raw.slice(firstDot + 1).replace(/\./g, '');
    }
    this.amountText = raw;
  }

  confirm(): void {
    if (this.converted <= 0) return;
    this.dialogRef.close(this.converted);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
